import { collection, doc, getDoc, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import { buildHighlightEntry } from '../highlights';
import { normalizeLocationId } from '../location';
import { resolveAccessLocationId } from '../access';

// A direct link can open an older record that is outside the current feed page.
export function isSightingVisibleOrLinked(entry, visibleSightings, linkedId) {
  if (!entry) return false;
  return visibleSightings.some((item) => item.id === entry.id)
    || Boolean(linkedId && entry.meta?.parentPath === `sightings/${linkedId}`);
}

export async function loadSightingLink(id, { isAdmin, allowedLocations }) {
  if (typeof id !== 'string' || !/^[A-Za-z0-9_-]{1,256}$/.test(id)) throw new Error('This sighting link is invalid.');
  const parentRef = doc(db, 'sightings', id);
  const snapshot = await getDoc(parentRef);
  if (!snapshot.exists() || snapshot.data().deletedAt) throw new Error('This sighting is no longer available.');
  const parentDoc = { ...snapshot.data(), id: snapshot.id };
  const accessId = normalizeLocationId(resolveAccessLocationId(parentDoc.cameraId, parentDoc.clientId, parentDoc.locationId, parentDoc.location));
  if (!isAdmin && !allowedLocations.has(accessId)) throw new Error('This sighting is not available for your assigned locations.');
  const species = (await getDocs(collection(parentRef, 'perSpecies'))).docs.filter((item) => !item.data().deletedAt);
  const chosen = species.find((item) => item.id === parentDoc.highlightSourceSpeciesDocId) || species[0];
  const speciesDoc = chosen ? { ...chosen.data(), id: chosen.id } : parentDoc;
  const entry = buildHighlightEntry({ category: 'sighting', parentDoc, speciesDoc });
  return { ...entry, id: `${entry.id}::${chosen?.id || 'parent'}`, meta: { parentPath: parentRef.path,
    parentDoc, speciesDoc, speciesDocPath: chosen?.ref.path || '' } };
}
